import React from 'react'
import clockIcon from '@/assets/images/svg/stepper/clock-icon.svg';
import tickIcon from '@/assets/images/svg/stepper/tick-white.svg';

const StepperSidebar = ({ activeStep , percentage }) => {
  console.log(" >>>>>>. activeStep <<<<<<<<<< ", activeStep);
  
  const steps=[
    {
      id:1,
      title:'Build Your Profile',
      decs:'Present your business professionally and build buyer trust.'
    },
    {
      id:2,
      title:'Showcase Your Products',
      decs:'Promote your products and attract relevant buyer inquiries.'
    },
    {
      id:3,
      title:'Choose Your Plan',
      decs:'Select a plan to increase visibility and access more opportunities.'
    },
    {
      id:4,
      title:'Profile Activated',
      decs:'Your registration is complete. Start exploring global business opportunities.'
    },
  ]
  
  return (
    <>
       <div className='stepper-sidebar-wrape'>
             <div className='steps-card position-relative'>
                
                  {
                    steps.map((item) => (

                        <div
                            className={`stepper-item
                            ${activeStep === item.id ? "active" : ""}
                            ${activeStep > item.id ? "completed" : ""}`}
                            key={item.id}
                        >

                            <div className="step-count">

                                <span className="step-circle">

                                    {activeStep >= item.id ? <img src={tickIcon} alt='tick-icon' /> : item.id}

                                </span>

                                {
                                    item.id !== steps.length &&
                                    <span className="step-line"></span>
                                }

                            </div>

                           <div className='step-content'>
                            <div className='step-title'>
                              {item.title}
                            </div>
                            <p className='step-decs text-muted'>
                              {item.decs}
                            </p>
                           </div> 
                        </div>

                    ))
                }

                          
             </div>

             <div className='profile-progress-wrape card'>
              <div className="card-body">
                 <div className='progress-header'>
                   <img src={clockIcon} alt="clock-icon" />
                <div>{percentage}% Profile Completed</div>
                 </div>
                 <div className='progress-content'>
                  <div className='progress'>
                    <div className='progress-bar' style={{ width: `${percentage === 80 ? 100 : percentage}%`}}>
                    </div>
                  </div>
                  <div className='text-end'>
                      Step {activeStep}/4
                    </div>
                 </div>   
              </div>
             </div>

       </div>
    </>
  )
}

export default StepperSidebar


